import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Space } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import Slider from "react-slick";

// HELPERS
import { encode } from 'Helpers/enc';

import './category-card.scss'

interface CategoryProps {
  _id: string;
  name: string;
  imageUrl: string;
  href: string;
}

export interface CategoryListProps {
  categories: CategoryProps[],
}

export const CategoryCard: React.FC<CategoryListProps> = ({ categories }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const onCategoryClick = (category) => {
    history.push('/products/catalog/list?name='+encode(category.name)+'&category='+encode(category._id))
  }


  return (
    <div className="category-card">
      <div className="scrollableCard">
        {map(categories, (category, index) => {
          return (
              <Card bordered={false} 
              className='card' 
              cover= {<img
              alt={t('alt.category')}
              src={category.imageUrl}
                />}
              onClick={() => onCategoryClick(category)}>
              <p>{category.name}</p>
              </Card>
          )
        })}
      </div>
    </div>

  )
}

export default CategoryCard;